import type { LoqateErrorItem } from "./types";

export class LoqateAddressLookupError extends Error {
  response: LoqateErrorItem;

  constructor(response: LoqateErrorItem) {
    super(response.Description);
    this.name = "LoqateAddressLookupError";
    this.response = response;
  }
}
